import React, { useEffect, useState } from "react";
import { Card, Tabs, Row, Col } from "antd";
import TicketsTable from "./TicketsTable";
import NewTicketModal from "./NewTicketModal";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";

const { TabPane } = Tabs;

export default function Tickets() {
  const general = useGeneralStore();
  const [currentKey, setCurrentKey] = useState(0);

  useEffect(() => {
    callback(currentKey);
  }, []);

  function callback(key) {
    general.getTickets({ id: key, isTicket: true, fromDate: null, toDate: null });
  }

  return (
    <Card>
      <Row
        gutter={[16, 16]}>
        <Col span={24}>
          <button type="primary" className="btn btn-primary waves-effect waves-light float-left"
            onClick={() => general.ToggleNewTicketModal()}
            style={{ marginBottom: "-40px" }}>
            <i className="fas fa-plus font-size-14 align-middle mr-2"></i> افزودن تیکت جدید
          </button>
        </Col>
        <Col span={24}>
          <Tabs defaultActiveKey="0" onChange={callback} centered onTabClick={(key => setCurrentKey(key))}>
            <TabPane tab="در دست بررسی" key="0" >
              <TicketsTable />
            </TabPane>
            <TabPane tab="پاسخ داده شده" key="1" >
              <TicketsTable />
            </TabPane>
          </Tabs>
          <NewTicketModal />
        </Col>
      </Row>
    </Card>
  );
}
